const NAME = 'RECIPES';
export const SET_SEARCH = `${NAME}/SET_SEARCH`;
export const SET_RECIPE_RESULTS = `${NAME}/SET_RECIPE_RESULTS`;
export const SET_SHARED_RECIPE_RESULTS = `${NAME}/SET_SHARED_RECIPE_RESULTS`;
export const SET_AUTO_COMPLETE_RESULTS = `${NAME}/SET_AUTO_COMPLETE_RESULTS`;
export const SET_SELECTED_RECIPE = `${NAME}/SET_SELECTED_RECIPE`;
export const CLEAR_SELECTED_RECIPE = `${NAME}/CLEAR_SELECTED_RECIPE`;
export const SET_TAGS = `${NAME}/SET_TAGS`;
export const SET_TAGS_LOADING = `${NAME}/SET_TAGS_LOADING`;
